import { Link } from "react-router-dom";

export function Logo({ className = "", dark = false }) {
  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src="/stukjes-logo.png"
        alt="Stukjes Spare Parts"
        className={`h-9 w-auto object-contain ${dark ? "brightness-0 invert" : ""}`}
      />
      <span className={`whitespace-nowrap text-[11px] font-medium ${dark ? "text-blue-200" : "text-slate-400"}`}>
        by Pactly<sup className="text-[8px]">®</sup>
      </span>
    </Link>
  );
}
